import { createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withKeys as _withKeys, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3429a18a")

_pushScopeId("data-v-3429a18a")
const _hoisted_1 = { class: "login" }
const _hoisted_2 = /*#__PURE__*/_createVNode("label", null, "メールアドレス", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("label", null, "パスワード", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("span", null, "ログイン", -1)
const _hoisted_5 = { class: "reset-password colspan" }
const _hoisted_6 = { class: "form" }
const _hoisted_7 = /*#__PURE__*/_createVNode("label", null, "メールアドレス", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "colspan" }, [
  /*#__PURE__*/_createVNode("p", null, "ユーザのメールアドレス宛にリセット用URLが送信されます。"),
  /*#__PURE__*/_createVNode("p", null, "リセット用URLからパスワードの再設定を行ってください。")
], -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("span", null, "リセット", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")
  const _component_modal = _resolveComponent("modal")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", {
        class: "form",
        onKeydown: _cache[5] || (_cache[5] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.enterAction && _ctx.enterAction(...args)), ["prevent"]), ["enter"]))
      }, [
        _hoisted_2,
        _withDirectives(_createVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.email = $event))
        }, null, 512), [
          [_vModelText, _ctx.email]
        ]),
        _hoisted_3,
        _withDirectives(_createVNode("input", {
          type: "password",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.password = $event))
        }, null, 512), [
          [_vModelText, _ctx.password]
        ]),
        _createVNode(_component_ErrorMessage, {
          messages: _ctx.errorMessages.LoginError
        }, null, 8, ["messages"]),
        _createVNode("button", {
          class: "app-button login-button colspan",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.signin && _ctx.signin(...args)))
        }, [
          _hoisted_4
        ]),
        _createVNode("div", _hoisted_5, [
          _createVNode("a", {
            href: "#",
            onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.preReset && _ctx.preReset(...args)), ["prevent"]))
          }, " パスワードを忘れた方はこちら ")
        ])
      ], 32),
      _createVNode(_component_modal, {
        isShow: _ctx.isResetMode,
        "onUpdate:isShow": _cache[8] || (_cache[8] = ($event: any) => (_ctx.isResetMode = $event)),
        title: "パスワードのリセット",
        isFitSize: true,
        onKeydown: _withKeys(_withModifiers(_ctx.enterAction, ["prevent"]), ["enter"])
      }, {
        default: _withId(() => [
          _createVNode("div", _hoisted_6, [
            _hoisted_7,
            _withDirectives(_createVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.resetEmail = $event))
            }, null, 512), [
              [_vModelText, _ctx.resetEmail]
            ]),
            _createVNode(_component_ErrorMessage, {
              messages: _ctx.errorMessages.ResetEmail
            }, null, 8, ["messages"]),
            _hoisted_8,
            _createVNode("button", {
              class: "app-button colspan",
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.reset && _ctx.reset(...args))),
              disabled: !_ctx.resetEmail
            }, [
              _hoisted_9
            ], 8, ["disabled"])
          ])
        ]),
        _: 1
      }, 8, ["isShow", "onKeydown"])
    ])
  ]))
})